// filepath: apps/web/src/apex/apexTenantSlug.ts
//
// ISS-f4fa1b7b-297 — synthetic tenant slug for the apex-landing
// provider tree.
//
// <ApexLandingPage> mounts <AppChrome variant="apex">, and
// <AppChrome> reads the tenant slug via useTenant() to drive the
// tenant-config fetch (which is short-circuited on apex, see
// AppChrome.tsx:430 and useEnvBadge.ts). For the apex branch to
// satisfy <TenantProvider>'s required prop without a string
// literal in App.tsx (which would trip the
// `tenantAgnosticBuild.test.ts` static guard against hardcoded
// tenantSlug strings), we expose this constant as a module
// import.
//
// The value "apex" is intentionally NOT a real tenant slug —
// the Go backend's resolver 404s any /api/tenant-config for it.
// AppChrome's tenant-config call is gated to `""` (which
// disables the underlying useQuery), so the apex branch never
// hits the wire with this slug.

export const APEX_TENANT_SLUG = "apex";
